import { Provider } from "react-redux";
import { RouterProvider } from "react-router-dom";
import { store } from "./store/store";
import { router } from "./router";
import { WebVersion } from "./components/helpers/Versioner";
import { initInstace } from "./helpers/HowlHelper";


function App() {
	initInstace()
	return (
		<Provider store={store}>
			<WebVersion></WebVersion>
			<RouterProvider router={router} />
		</Provider>
	);
}

export default App;
